/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKubernetesHelm = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.528 8H5.07c.183-.316.387-.619.61-.906L4.293 5.707l1.414-1.414L7.094 5.68A7.96 7.96 0 0 1 11 4.062V2h2v2.062a7.962 7.962 0 0 1 3.985 1.68l1.45-1.45 1.414 1.415-1.467 1.468c.199.263.382.538.548.825h-2.458C15.374 6.772 13.777 6 12 6s-3.373.772-4.472 2zM11 22v-2.062a7.96 7.96 0 0 1-3.905-1.618l-1.388 1.387-1.414-1.414 1.387-1.387A8.014 8.014 0 0 1 5.07 16h2.458c1.099 1.227 2.695 2 4.472 2s3.374-.773 4.472-2h2.458a8.017 8.017 0 0 1-.61.906l1.387 1.387-1.414 1.414-1.387-1.387A7.96 7.96 0 0 1 13 19.938V22zM4 10v4h.921v-1.662h1.76V14h.922v-4h-.921v1.612h-1.76V10zm4.441 0v4h2.853v-.726H9.363v-.93h1.701v-.726H9.363v-.892h1.872V10zm3.519 4v-4h.921v3.235h1.89V14zm3.403-4v4h.892v-2.558l1.134 2.173h.567l1.134-2.207V14H20v-4h-.963l-1.346 2.635L16.326 10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgKubernetesHelm as KubernetesHelm };
